import { Editor } from "tinymce";
import { FeatureClass } from "../core/FeatureClass";
import { b64ToImg, getData, insertToEditor, setWindowNode, toJsonHtml } from "../core/Utils";
import { renderChart, renderChartForEditor, transformDataToChartData } from "../../Loads/RenderChart";
import { makeEditorModal } from "../Modal";
import { uniqueRandomId } from "../save/SaveUtils";
import { turnPictureToLabelingTask } from "../Inputs/Labeling";


export interface ChartData {
    values: Array<Array<string>>, // Data for each data-row
    names: Array<string>, // Names for each data-row
    labels: Array<string>, // Labels that affect all rows
    id?: string;
    chartType: string; // line, column, pie
    type?: string;
    height?: number;
    width?: number;
}

export function addChart(editor:Editor){
    const config = {
        featureName: "chart",
        editor: editor,
        id: "chart",
        icon: "contrast",
        tooltip: 'Diagramm erstellen',
        menuItems: [{
            name: 'edit-chart',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                if (Apex._chartInstances !== undefined && Apex._chartInstances.length > 0){
                    ApexCharts.exec('display-chart', 'destroy')
                }

                const node = setWindowNode(editor);
                const data = getData(node);

                createChartModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            if (Apex._chartInstances !== undefined && Apex._chartInstances.length > 0){
                ApexCharts.exec('display-chart', 'destroy')
            }
            const empty = {
                labels: ['1', '2', '3'],
                names: ['Daten'],
                values: [['1', '2', '3']],
                chartType: 'bar',
            }
            createChartModal(editor, command, empty);
        },
        commandAction: (data:ChartData) => {
            insertChart(data, editor);
        }    
    }
    // Make it labelable as a picture
    config.menuItems.push(turnPictureToLabelingTask())

    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

export function addChartListeners(){
    $(document).on("blur input change", ".chart-modal input", function(){
        renderCurrentChart();
    })
    $(document).on("click", ".add-chart-row", function(){
        const data = getDataFromModal($(".chart-modal"))
        data.labels.push("")
        for (let i = 0; i < data.values.length; i++){
            data.values[i].push("");
        }
        const html = renderChartInputData(data);
        $(".chart-data").html(html);
    });
    $(document).on("click", ".remove-chart-row", function(){
        $(this).parents("tr").remove()
        renderCurrentChart();
    });

    $(document).on("click", ".change-chart-type", function(){
        const newType = $(this).attr('data-type');
        $("#chart-type").val(newType);
        renderCurrentChart();
    })
}

function createChartModal(editor:Editor, command:string, data:ChartData){


    const content = '<div class="chart-modal">' + 
    '<div class="row" style="min-height: 350px;">' + 
        '<div class="col-sm-12 col-md-5">' + 
            '<div class="chart-type">' + 
                renderChartTypes(data.chartType) + 
            '</div>' + 
            '<div class="chart-data">' + 
                renderChartInputData(data) + 
            '</div>' + 
        '</div>' + 
        '<div class="col-sm-12 col-md-7">' + 
            '<div id="display-chart"></div>' + 
        '</div>' + 
    '</div>' + 
    '</div>';

    const settings = {
        submitBtn: {
            text: "Einfügen",
            class: "add-chart"
        },
        size: "xl"
    }

    const modalId = "create-chart";
    const onclick = function(modal){
        const data = getDataFromModal(modal);
        if (data){
            editor.execCommand(command, data)
            return true;
        }
    }

    const modal = makeEditorModal(modalId, 'Datenvisualisierung erstellen', content, settings, onclick);

    renderCurrentChart();
}

function getDataFromModal(modal:JQuery):ChartData{
    const labels = [];
    const values = [];
    const names = [];
    // Names
    modal.find(".chart-name").each((ind, obj) => {
        
        const name = $(obj).val();
        names.push(name)
    })
    
    // Labels
    modal.find(".c-l").each((ind, obj) => {
        const label = $(obj).val();
        labels.push(label)
    })

    // Values
    modal.find(".c-v").each((ind, obj) => {
        const chartIndex = $(obj).attr('data-index')
        if (values[chartIndex] == undefined){
            values[chartIndex] = [];
        }
        let value = $(obj).val().replace(",", ".");
        value = (value === '' || value === NaN) ? 0 : value; 
        values[chartIndex].push(value);
    })
    // Chart-Type
    const type = $("#chart-type").val();

    return {
        labels: labels,
        values: values,
        names: names,
        chartType: type
    }
}

function renderChartTypes(type = ''):string{
    const buttons = {
        'bar': {
            'icon': 'mdi-chart-bar',
        },
        'pie': {
            'icon': 'mdi-chart-pie',
        },
        'line':{
            'icon': 'mdi-chart-line',
        }
    }
    let s = '<div class="btn-group mb-2">'
    for (const[key, value] of Object.entries(buttons)){
        s += '<button type="button" data-type="' + key + '" class="change-chart-type btn btn-light-primary text-primary font-weight-medium'
        if (key == type){
            s += ' selected chosen'
        }
        s += '"><i class="mdi ' + value.icon + '"></i></button>'
    }
    s += '<input type="hidden" id="chart-type" value="' + type + '">'
    s += '</div>'
    return s;
}

function renderChartInputData(data:ChartData){
    const height = (data.height !== undefined) ? data.height : 310;
    const width = (data.width !== undefined) ? data.width : 550;

    let html = '<table class="w-100">' + 
        '<thead>' + 
            '<tr>' + 
                '<th class="no-border"></th>' + 
                '<th>Label</th>' +
                renderChartNames(data.names) + 
            '</tr>' + 
        '</thead>' + 
        '<tbody>' +
            renderChartValues(data.labels, data.values) + 
        '</tbody>' + 
    '</table>';
    html += '<input id="width" type="hidden" value="' + width + '">' + 
            '<input id="height" type="hidden" value="' + height + '">';
    html += '<div class="text-center mt-2"><button class="btn btn-light-success text-success add-chart-row w-50"><i class="mdi mdi-plus-circle-outline"></i></button></div>'
    return html;
}

function renderChartValues(labels:Array<string>, values:Array<Array<number>>):string{
    let s = '';
    for ( let i = 0; i < labels.length; i++){
        s += '<tr>'
        s += '<td class="border-0 text-center">'
        if (i > 0){
            s += '<button class="btn btn-light-danger text-danger remove-chart-row"><i class="mdi mdi-delete"></i></button>'
        }
        s += '</td>'
        s += '<td><input type="text" class="form-control c-l" value="' + labels[i] + '"></td>' // Label
        for ( let j = 0; j < values.length; j++){
            s += '<td><input type="text" class="form-control c-v" data-index="' + j + '" value="' + values[j][i] + '"></td>'
        }
        s += '</tr>' 
    }
    s += ''
    return s;
}

function renderChartNames(names:Array<string>):string{
    if (names.length > 0){
        let s = '';
        names.forEach((name) => {
            s += '<th><input type="text" class="form-control chart-name" value="' + name + '"></th>'
        })
        return s;
    } else {
        return '<th><input type="text" class="form-control chart-name"></th>'
    }
}


function insertChart(data:ChartData, editor:Editor){

    ApexCharts.exec("display-chart", "dataURI").then(({imgURI, blob}) => {
        const b64 = imgURI;
        
        const btn = $(".add-chart");
        b64ToImg(data, editor, b64, insertChartToEditor, btn);
        
        ApexCharts.exec('display-chart', 'destroy')
    })

}

function insertChartToEditor(data:ChartData, editor:Editor, url:string){

    const html = transformChartForInsert(data, url);
    insertToEditor(html, editor);

}

function transformChartForInsert(data:ChartData, url:string):string{
    data.type = "chart",
    data.id = uniqueRandomId(5)
    
// missing
    data = addDimensionsToData(data);

    const json = toJsonHtml(data);
    const html = '<img id="chart" data-json="' + json + '" width="' + data.width + 'px" height="auto" class="mceNonEditable prop-item prop-chart" src="' + url + '">'
    return html;
}

function addDimensionsToData(data:any):GraphData{
    const f = $(".chart-modal");
    data.width = f.find("#width").val();
    // data.height = f.find("#height").val();
    return data;
}

function renderCurrentChart(){
    const data = getDataFromModal($(".chart-modal"));
    
    const chartData = transformDataToChartData(data);
    
    renderChartForEditor(chartData);
}

export function transformChart(data:ChartData, displayCodeObj:boolean|HTMLElement = false){
    
    const origWidth = (data.width !== undefined) ? data.width : 550;
    if (displayCodeObj && $(displayCodeObj).attr('height') !== undefined){
        data.width = Number($(displayCodeObj).attr('width').replace("px", ""));
        // data["height"] = parseInt($(displayCodeObj).attr('height').replace("px", ""));
    } else {
        data = addDimensionsToData(data);
        if (data.width == undefined){
            data.width = origWidth;
        }
    }

    const id = data.id;

    
    const html = '<div id="' + id + '" class="display-chart prop-item prop-load-item d-inline-block" data-json="' + toJsonHtml(data) + '"></div>'; 
    return html;

}